import React from 'react';

/**
 * 地图视觉中心的淡色小圆点（对应「中心海拔」采样点）
 * 用 CSS 固定在视口中心，切底图也不丢。
 */
export default function DashboardMapCenterDot({ visible = true }) {
  if (!visible) return null;
  return (
    <div
      aria-hidden
      title="地图中心（中心海拔采样点）"
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 5,
        height: 5,
        marginLeft: -2.5,
        marginTop: -2.5,
        borderRadius: '50%',
        background: 'rgba(20, 20, 20, 0.28)',
        boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.45)',
        pointerEvents: 'none',
        zIndex: 6
      }}
    />
  );
}
